import {
    DesktopOutlined,
    AppstoreAddOutlined,
    PieChartOutlined,
    TeamOutlined,
    UserOutlined,
    ShoppingOutlined,
    DollarCircleOutlined,
    StockOutlined,
    LockOutlined,
    ArrowDownOutlined,
    FileTextOutlined
} from '@ant-design/icons';

// Import components
import Users from './components/pages/users/users';
import HomePage from './components/pages/homePage';
import Shops from './components/pages/shops/shops';
import Roles from './components/pages/users/roles';
import Categories from './components/pages/product/category';
import Products from './components/pages/product/products';
import ExpiredProducts from './components/pages/product/expired_products';
import InventoryManagement from './components/pages/product/inventory_management';
import SubCategories from './components/pages/product/subcategory';
import Customers from './components/pages/users/customers';
import Vendors from './components/pages/users/vendors';
import Accounts from './components/pages/accounts/accounts';
import PurchaseOrder from './components/pages/purchase_order/post_purchase_order';
import PurchaseOrderList from './components/pages/purchase_order/purchase_order_list';
import PurchaseOrderEdit from './components/pages/purchase_order/purchase_order_edit';
import PurchaseOrderView from './components/pages/purchase_order/purchase_order_view';
import PostSales from './components/pages/sales/post_sales_order';
import SalesList from './components/pages/sales/sales_list';
import SalesView from './components/pages/sales/view_sales';
import EditSales from './components/pages/sales/edit_sales';
import ProductSales from './components/pages/sales/product_sales';
import CloseSales from './components/pages/sales/close_reverse_sales';
import PostAdjustment from './components/pages/adjustment/post_adjustment';
import ProductAdjustments from './components/pages/adjustment/view_adjustments';
import RolePermissionGroupList from './components/pages/permission/role_group_permission';
import Debits from './components/pages/Debits/debits';
import SalesReports from './components/pages/Reports/sales_reports';
import { getUserData } from './components/constants';
import UserPermissionTable from './components/pages/permission/user_operations_permission';
import UserChats from './components/pages/chats/userchats';

const userData = getUserData();
// const rolePermission = userData && userData.user ? userData.user.role.role_permission : {};
const rolePermission = userData?.user?.role?.role_permission || {};


const routes = [
    { path: '/home', label: 'Dashboard', key: '1', icon: <PieChartOutlined />, component: HomePage },

    // Manage Routes
    ...(rolePermission.is_manage ? [{
        label: 'Manage',
        key: 'manage',
        icon: <UserOutlined />,
        children: [
            { path: '/manage/users', label: 'Users', key: '3', component: Users },
            { path: '/manage/shops', label: 'Shops', key: '4', component: Shops },
            { path: '/manage/roles', label: 'Roles', key: '5', component: Roles },

        ],
    }] : []),

    // Permissions
    ...(rolePermission.is_manage ? [{
        label: 'Permissions',
        key: 'permissions',
        icon: <LockOutlined />,
        children: [
            { path: '/manage/roles-permission', label: 'Roles Permission', key: '21', component: RolePermissionGroupList },
            { path: '/manage/employee-permission', label: 'Employee Permission', key: '22', component: UserPermissionTable },
        ],
    }] : []),
    // Items Routes
    ...(rolePermission.is_stock ? [{
        label: 'Items',
        key: 'items',
        icon: <AppstoreAddOutlined />,
        children: [
            { path: '/products', label: 'Products', key: '9', component: Products },
            { path: '/product/category', label: 'Categories', key: '10', component: Categories },
            { path: '/product/sub-category', label: 'Sub Categories', key: '11', component: SubCategories },
            { path: '/product/inventory', label: 'Inventory Management', key: '12', component: InventoryManagement },
            { path: '/product/expired', label: 'Expired Products', key: '13', component: ExpiredProducts },
        ],
    }] : []),

    // Purchase Routes
    ...(rolePermission.is_stock ? [{
        label: 'Purchase',
        key: 'po',
        icon: <ShoppingOutlined />,
        children: [
            { path: '/manage/vendors', label: 'Vendors', key: '7', component: Vendors },
            { path: '/purchase-order', label: 'Purchase Order', key: '14', component: PurchaseOrder },
            { path: '/purchase-orders', label: 'Purchase Order Lists', key: '15', component: PurchaseOrderList },
            { path: '/purchase-orders/edit/:id', label: 'Edit Purchase Order', key: 'hide', component: PurchaseOrderEdit },
            { path: '/purchase-orders/view/:id', label: 'View Purchase Order', key: 'hide', component: PurchaseOrderView },
        ],
    }] : []),

    // Sales Routes
    ...(rolePermission.is_sales ? [{
        label: 'Sale',
        key: 'sale',
        icon: <DollarCircleOutlined />,
        children: [
            { path: '/manage/customers', label: 'Customers', key: '6', component: Customers },
            { path: '/manage/accounts', label: 'Accounts', key: '8', component: Accounts },
            { path: '/post-sales', label: 'Post Sales', key: '16', component: PostSales },
            { path: '/sales-list', label: 'Sales Lists', key: '17', component: SalesList },
            { path: '/sales/edit/:id', label: 'Edit Sale', key: 'hide', component: EditSales },
            { path: '/sales/view/:id', label: 'View Sale', key: 'hide', component: SalesView },
            { path: '/sales/view/product', label: 'Product Sales', key: '18', component: ProductSales },
            { path: '/sales/close-reverse', label: 'Close Day sales', key: '19', component: CloseSales },
        ],
    }] : []),

    // Stock Adjustment Routes
    ...(rolePermission.is_stock ? [{
        label: 'Stock Adjustment',
        key: 'stock',
        icon: <StockOutlined />,
        children: [
            { path: '/post-stock-adjustment', label: 'Post Stock Adjustment', key: '20', component: PostAdjustment },
            { path: '/product-stock-adjustment', label: 'Products Stock Adjustments', key: '21', component: ProductAdjustments },
        ],
    }] : []),


    // Debits Routes
    ...(rolePermission.is_sales ? [{
        label: 'Debits',
        key: 'Debits',
        icon: <ArrowDownOutlined />,
        children: [
            { path: '/view-invoice-debits', label: 'Invoice Debits', key: '22', component: Debits },

        ],
    }] : []),

    // Reports Routes
    ...(rolePermission.is_sales ? [{
        label: 'Reports',
        key: 'Reports',
        icon: <FileTextOutlined />,
        children: [
            { path: '/view-sales-reports', label: 'View sales reports', key: '23', component: SalesReports },

        ],
    }] : []),

    ...(rolePermission.is_sales ? [{
        label: 'Chats',
        key: 'chats',
        icon: <TeamOutlined />,

        children: [
            { path: '/Chatting', label: 'My Coversations', key: '31', component: UserChats },
        ],
    }] : []),
];

export default routes;